import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { ConstitucionPrestamosModel, PrestamosModel } from './prestamos.model';
import { PrestamosListComponent } from './prestamos-list.component';
import { PrestamosService } from './prestamos.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-prestamosconstitucion',
    templateUrl: './prestamos-dialog-constitucion.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosDialogConstitucionComponent implements OnInit {

  public prestamos: PrestamosModel = this.data.prestamos;

  public constitucionPrestamos: ConstitucionPrestamosModel = new ConstitucionPrestamosModel();

  public depositSaved: boolean = false;

  public ready: boolean = false;

  public isEditMode: boolean = false;

  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];

  public dataSource: ConstitucionPrestamosModel[] = [];
  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importe', title: 'Importe', cell: (row) => `${row.importe}  `, class: (row) => `` },
    { field: 'comisionApertura', title: 'Comisión Apertura', cell: (row) => `${row.comisionApertura}  `, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public tittle: string = '';

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporte: boolean = false;
  public invalidBankAccount: boolean = false;

  public activities: ActivityModel[] = [];

  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PrestamosListComponent>,
    public prestamosService: PrestamosService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private masterService: MasterService,
    private cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.ready = false;

    this.activityService.getList()
      .then(response => {
        this.activities = response;
      });

      this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
            this.isProjectEnable = activity.isProject;
          });
    // Corto plazo
    if (this.prestamos.duracion === 1) {
      this.tittle = 'a corto plazo';
    }

    // Largo plazo
    if (this.prestamos.duracion === 2) {
      this.tittle = 'a largo plazo';
    }

    this.bankAccountService.getList()
      .then(bankAccounts => {
        this.bankAccounts = bankAccounts.list;

        if (this.isEditMode === false) {
          this.constitucionPrestamos.bankAccountsUid = this.prestamos.bankAccountsUid;
        }

        this.ready = true;
      });


    //Projects

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    })

    //Expense Project Types
    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes = data;
      this.cdr.detectChanges();
    })

    this.getData();

    // Auto-fill
    if (this.isEditMode === false) {
      this.constitucionPrestamos.fecha = this.prestamos.fechaConstitucion;
      this.constitucionPrestamos.comisionApertura = this.prestamos.comisionApertura;
      this.constitucionPrestamos.importe = this.prestamos.importeInicial;
    }
  }

 public pay(): void {
  // Asignamos el uid del préstamo
  this.constitucionPrestamos.prestamosId = this.prestamos.uid;

  let noError = true;

  // Validaciones reales
  if (!this.constitucionPrestamos.fecha) {
    noError = false;
    this.invalidDate = true;
  }

  if (!this.constitucionPrestamos.concepto || this.constitucionPrestamos.concepto.trim() === '') {
    noError = false;
    this.invalidConcept = true;
  }

  if (!this.constitucionPrestamos.importe || this.constitucionPrestamos.importe === 0) {
    noError = false;
    this.invalidImporte = true;
  }

  if (
    !this.constitucionPrestamos.bankAccountsUid ||
    this.constitucionPrestamos.bankAccountsUid === consts.EMPTY_GUID
  ) {
    noError = false;
    this.invalidBankAccount = true;
  }

  if (!this.constitucionPrestamos.activitiesUid) {
    noError = false;
  }

  // if (!this.constitucionPrestamos.projectUid || !this.constitucionPrestamos.expenseProjectTypeUid) {
  //   noError = false;
  //   this.displayInfo("Debe seleccionar un proyecto y tipo de proyecto de gasto");
  // }

  if (noError) {

    const request = this.isEditMode
      ? this.prestamosService.constitucionUpdate(this.constitucionPrestamos)
      : this.prestamosService.constitucionCreate(this.constitucionPrestamos);

    request
      .then(() => (this.depositSaved = true))
      .catch(() => this.displayInfo("Ha ocurrido un error al guardar el elemento"));
  } else {
    this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
  }
}




  public getData(): void {
    this.depositSaved = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporte = false;
    this.invalidBankAccount = false;

    this.list = false;
    this.dataSource = [];

    this.prestamosService.constitucionList(this.prestamos.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.list = true;
        }
      })
      .catch(error => {
      });
  }

  public delete(uidElement: string): void {
    // Este uid es el id
    this.prestamosService.constitucionDelete(uidElement)
      .then(responseDelete => {
        this.getData();
      })
      .catch(err => {
        this.displayInfo("Ha ocurrido un error al eliminar la constitución");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.depositSaved = false;

    this.constitucionPrestamos = elementSearched;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public trackByIndex(i: number) { return i; }

}
